###
# Группа модификаторов
###

App.ModifierGroup = DS.Model.extend

  visible            : DS.attr 'boolean'
  name               : DS.attr 'string'
  prompt             : DS.attr 'string'
  min                : DS.attr 'number'
  max                : DS.attr 'number'
  view_type          : DS.attr 'string'
  photo              : DS.attr 'mixed'
  view_order         : DS.attr 'number'
  external_id        : DS.attr 'string'

  organization       : DS.belongsTo 'organization', async: true
  modifiers          : DS.hasMany 'modifier', async: true
  modifiersSortOrder : ['view_order']
  sortedModifiers    : Em.computed.sort('modifiers', 'modifiersSortOrder')
